import React, { Component } from "react";

//Common Functions
import * as format from "../../../common/FormatFunctions";
import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";

//import "./CustomCSS/charts.css";
export class DashboardEvents extends Component {
  constructor() {
    super();
    this.state = {
      activities: [
        {
          name: "James",
          message: "Updated Work 1 to In Progress",
          time: "just now"
        },
        {
          name: "Mary",
          message: "Updated ORD004",
          time: "just now"
        },
        {
          name: "Syatem",
          message: "CNC InActive",
          time: "2 mins ago"
        },
        {
          name: "System",
          message: "Laser Broken",
          time: "3 mins ago"
        }
      ],
      loop: "Iteration 1"
    };
  }

  componentDidMount = () => {
    this.initialDataRender();
    this.interval = setInterval(() => this.refresh(), 5000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loading: true });

    this.setState({ loading: false });
  };

  refresh = () => {
    this.setState({ loading: true });
    console.log("Refreshing...");
    console.log(this.state);
    console.log(this.state.loop);
    var localRefreshState = format.deepCopy(this.state.loop);
    if (localRefreshState === "Iteration 1") {
      console.log("Changing Iteration 1 --> 2");
      this.setState({
        activities: [
          {
            name: "John",
            message: "Updated Work 1 to In Progress",
            time: "just now"
          },
          {
            name: "System",
            message: "CNC Saw Fault",
            time: "2 mins ago"
          },
          {
            name: "James",
            message: "Updated Work 1 to In Progress",
            time: "5 mins ago"
          },
          {
            name: "Mary",
            message: "Updated ORD004",
            time: "5 mins ago"
          }
        ],
        loop: "Iteration 2"
      });
    }

    if (localRefreshState === "Iteration 2") {
      console.log("Changing Iteration 2 --> 3");
      this.setState({
        activities: [
          {
            name: "Mary",
            message: "Updated ORD009",
            time: "just now"
          },
          {
            name: "John",
            message: "Updated Work 1 to In Progress",
            time: "3 mins ago"
          },
          {
            name: "System",
            message: "CNC Saw Fault",
            time: "5 mins ago"
          },
          {
            name: "James",
            message: "Updated Work 1 to In Progress",
            time: "8 mins ago"
          }
        ],
        loop: "Iteration 3"
      });
    }

    if (localRefreshState === "Iteration 3") {
      console.log("Changing Iteration 3 --> 1");
      this.setState({
        activities: [
          {
            name: "Mary",
            message: "Updated ORD0010",
            time: "just now"
          },
          {
            name: "Mary",
            message: "Updated ORD009",
            time: "3 mins ago"
          },
          {
            name: "John",
            message: "Updated Work 1 to In Progress",
            time: "6 mins ago"
          },
          {
            name: "System",
            message: "CNC Saw Fault",
            time: "8 mins ago"
          }
        ],
        loop: "Iteration 1"
      });
    }
    this.setState({ loading: false });
  };

  render() {
    return (
      <pr.Panel header="Activity" style={{ height: "100%" }}>
        {this.state.loading === true && <pr.Spinner />}
        {this.state.loading === false && (
          <div className="ui-g">{this.getActivities()}</div>
        )}
      </pr.Panel>
    );
  }

  getActivities = () => {
    var componentArray = [];
    var index = 0;

    this.state.activities.forEach(element => {
      componentArray[index] = (
        <div className="ui-g-12">
          <div className="ui-g-3">
            <span className="event-time">{element.time}</span>
            {/* <i className="material-icons" style={{ color: "#009688" }}>
              &#xE1BC;
            </i> */}
          </div>
          <div className="ui-g-9">
            <span className="event-owner" style={{ color: "#009688" }}>
              {element.name}
            </span>
            {"\n"}
            <span className="event-text">{element.message}</span>
          </div>
        </div>
      );
      index++;
    });

    return componentArray;
  };
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardEvents.js